import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const SpacialOffer = () => {
    const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <div className="hiraola-product_area hiraola-product_area-2 mb-4">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="hiraola-section_title">
              <h4>Special Offer</h4>
            </div>
          </div>

          <div className="col-lg-12">
            {/* ✅ PUT HERE (ABOVE SWIPER) */}
          <div className="slider-navigation">
            <button ref={prevRef} className="slick-prev slick-arrow"style={{marginLeft:"40px"}} >
              <i className="ion-ios-arrow-back" ></i>
            </button>

            <button ref={nextRef} className="slick-next slick-arrow" >
              <i className="ion-ios-arrow-forward"></i>
            </button>
          </div>
            <Swiper
            modules={[Navigation]}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
              loop
              spaceBetween={20}
              slidesPerView={4}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                576: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                992: {
                  slidesPerView: 4,
                },
              }}
              className="hiraola-product_slider-3"
            >
              {/* Product 1 */}
              <SwiperSlide>
                <div className="slide-item">
                  <div className="single_product">
                    <div className="product-img">
                      <a href="single-product.html">
                        <img
                          className="primary-img"
                          src="/assets/images/product/medium-size/1-1.jpg"
                          alt="Product"
                        />
                        <img
                          className="secondary-img"
                          src="/assets/images/product/medium-size/1-2.jpg"
                          alt="Product"
                        />
                      </a>

                      <span className="sticker">New</span>

                      <div className="add-actions">
                        
                      </div>
                    </div>

                   <div className="hiraola-product_content">
                      <div className="product-desc_info">

                        {/* Action Buttons */}
                        <div className="product-actions">
                          <ul>
                            <li>
                              <a className="hiraola-add_cart" href="cart.html">
                                <i className="ion-bag"></i>
                              </a>
                            </li>

                            <li>
                              <a className="hiraola-add_compare" href="compare.html">
                                <i className="ion-ios-shuffle-strong"></i>
                              </a>
                            </li>

                            <li
                              className="quick-view-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModalCenter"
                            >
                              <a href="#" onClick={(e) => e.preventDefault()}>
                                <i className="ion-eye"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <h6>
                          <a className="product-name" href="single-product.html">
                            Pendant, Made of White Pl...
                          </a>
                        </h6>

                        <div className="price-box">
                          <span className="new-price">£120.80</span>
                        </div>

                        <div className="additional-add_action">
                          <ul>
                            <li>
                              <a className="hiraola-add_compare" href="wishlist.html">
                                <i className="ion-android-favorite-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <div className="rating-box">
                          <ul>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li className="silver-color">
                              <i className="fa fa-star-of-david"></i>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              {/* Product 2 */}
              <SwiperSlide>
                 <div className="slide-item">
                  <div className="single_product">
                    <div className="product-img">
                      <a href="single-product.html">
                        <img
                          className="primary-img"
                          src="/assets/images/product/medium-size/1-1.jpg"
                          alt="Product"
                        />
                        <img
                          className="secondary-img"
                          src="/assets/images/product/medium-size/1-2.jpg"
                          alt="Product"
                        />
                      </a>

                      <span className="sticker">New</span>

                      <div className="add-actions">
                        
                      </div>
                    </div>

                   <div className="hiraola-product_content">
                      <div className="product-desc_info">

                        {/* Action Buttons */}
                        <div className="product-actions">
                          <ul>
                            <li>
                              <a className="hiraola-add_cart" href="cart.html">
                                <i className="ion-bag"></i>
                              </a>
                            </li>

                            <li>
                              <a className="hiraola-add_compare" href="compare.html">
                                <i className="ion-ios-shuffle-strong"></i>
                              </a>
                            </li>

                            <li
                              className="quick-view-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModalCenter"
                            >
                              <a href="#" onClick={(e) => e.preventDefault()}>
                                <i className="ion-eye"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <h6>
                          <a className="product-name" href="single-product.html">
                            Pendant, Made of White Pl...
                          </a>
                        </h6>

                        <div className="price-box">
                          <span className="new-price">£120.80</span>
                        </div>

                        <div className="additional-add_action">
                          <ul>
                            <li>
                              <a className="hiraola-add_compare" href="wishlist.html">
                                <i className="ion-android-favorite-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <div className="rating-box">
                          <ul>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li className="silver-color">
                              <i className="fa fa-star-of-david"></i>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              {/* Product 3 */}
              <SwiperSlide>
                <div className="slide-item">
                  <div className="single_product">
                    <div className="product-img">
                      <a href="single-product.html">
                        <img
                          className="primary-img"
                          src="/assets/images/product/medium-size/1-1.jpg"
                          alt="Product"
                        />
                        <img
                          className="secondary-img"
                          src="/assets/images/product/medium-size/1-2.jpg"
                          alt="Product"
                        />
                      </a>

                      <span className="sticker">New</span>

                      <div className="add-actions">
                        
                      </div>
                    </div>

                   <div className="hiraola-product_content">
                      <div className="product-desc_info">

                        {/* Action Buttons */}
                        <div className="product-actions">
                          <ul>
                            <li>
                              <a className="hiraola-add_cart" href="cart.html">
                                <i className="ion-bag"></i>
                              </a>
                            </li>

                            <li>
                              <a className="hiraola-add_compare" href="compare.html">
                                <i className="ion-ios-shuffle-strong"></i>
                              </a>
                            </li>

                            <li
                              className="quick-view-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModalCenter"
                            >
                              <a href="#" onClick={(e) => e.preventDefault()}>
                                <i className="ion-eye"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <h6>
                          <a className="product-name" href="single-product.html">
                            Pendant, Made of White Pl...
                          </a>
                        </h6>

                        <div className="price-box">
                          <span className="new-price">£120.80</span>
                        </div>

                        <div className="additional-add_action">
                          <ul>
                            <li>
                              <a className="hiraola-add_compare" href="wishlist.html">
                                <i className="ion-android-favorite-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <div className="rating-box">
                          <ul>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li className="silver-color">
                              <i className="fa fa-star-of-david"></i>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              {/* Product 4 */}
              <SwiperSlide>
                 <div className="slide-item">
                  <div className="single_product">
                    <div className="product-img">
                      <a href="single-product.html">
                        <img
                          className="primary-img"
                          src="/assets/images/product/medium-size/1-1.jpg"
                          alt="Product"
                        />
                        <img
                          className="secondary-img"
                          src="/assets/images/product/medium-size/1-2.jpg"
                          alt="Product"
                        />
                      </a>

                      <span className="sticker">New</span>

                      <div className="add-actions">
                        
                      </div>
                    </div>

                   <div className="hiraola-product_content">
                      <div className="product-desc_info">

                        {/* Action Buttons */}
                        <div className="product-actions">
                          <ul>
                            <li>
                              <a className="hiraola-add_cart" href="cart.html">
                                <i className="ion-bag"></i>
                              </a>
                            </li>

                            <li>
                              <a className="hiraola-add_compare" href="compare.html">
                                <i className="ion-ios-shuffle-strong"></i>
                              </a>
                            </li>

                            <li
                              className="quick-view-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModalCenter"
                            >
                              <a href="#" onClick={(e) => e.preventDefault()}>
                                <i className="ion-eye"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <h6>
                          <a className="product-name" href="single-product.html">
                            Pendant, Made of White Pl...
                          </a>
                        </h6>

                        <div className="price-box">
                          <span className="new-price">£120.80</span>
                        </div>

                        <div className="additional-add_action">
                          <ul>
                            <li>
                              <a className="hiraola-add_compare" href="wishlist.html">
                                <i className="ion-android-favorite-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <div className="rating-box">
                          <ul>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li className="silver-color">
                              <i className="fa fa-star-of-david"></i>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              {/* Product 5 */}
              <SwiperSlide>
                 <div className="slide-item">
                  <div className="single_product">
                    <div className="product-img">
                      <a href="single-product.html">
                        <img
                          className="primary-img"
                          src="/assets/images/product/medium-size/1-1.jpg"
                          alt="Product"
                        />
                        <img
                          className="secondary-img"
                          src="/assets/images/product/medium-size/1-2.jpg"
                          alt="Product"
                        />
                      </a>

                      <span className="sticker">New</span>

                      <div className="add-actions">
                        
                      </div>
                    </div>

                   <div className="hiraola-product_content">
                      <div className="product-desc_info">

                        {/* Action Buttons */}
                        <div className="product-actions">
                          <ul>
                            <li>
                              <a className="hiraola-add_cart" href="cart.html">
                                <i className="ion-bag"></i>
                              </a>
                            </li>

                            <li>
                              <a className="hiraola-add_compare" href="compare.html">
                                <i className="ion-ios-shuffle-strong"></i>
                              </a>
                            </li>

                            <li
                              className="quick-view-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModalCenter"
                            >
                              <a href="#" onClick={(e) => e.preventDefault()}>
                                <i className="ion-eye"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <h6>
                          <a className="product-name" href="single-product.html">
                            Pendant, Made of White Pl...
                          </a>
                        </h6>

                        <div className="price-box">
                          <span className="new-price">£120.80</span>
                        </div>

                        <div className="additional-add_action">
                          <ul>
                            <li>
                              <a className="hiraola-add_compare" href="wishlist.html">
                                <i className="ion-android-favorite-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <div className="rating-box">
                          <ul>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li className="silver-color">
                              <i className="fa fa-star-of-david"></i>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              {/* Product 6 */}
              <SwiperSlide>
                 <div className="slide-item">
                  <div className="single_product">
                    <div className="product-img">
                      <a href="single-product.html">
                        <img
                          className="primary-img"
                          src="/assets/images/product/medium-size/1-1.jpg"
                          alt="Product"
                        />
                        <img
                          className="secondary-img"
                          src="/assets/images/product/medium-size/1-2.jpg"
                          alt="Product"
                        />
                      </a>

                      <span className="sticker">New</span>

                      <div className="add-actions">
                        
                      </div>
                    </div>

                   <div className="hiraola-product_content">
                      <div className="product-desc_info">

                        {/* Action Buttons */}
                        <div className="product-actions">
                          <ul>
                            <li>
                              <a className="hiraola-add_cart" href="cart.html">
                                <i className="ion-bag"></i>
                              </a>
                            </li>

                            <li>
                              <a className="hiraola-add_compare" href="compare.html">
                                <i className="ion-ios-shuffle-strong"></i>
                              </a>
                            </li>

                            <li
                              className="quick-view-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModalCenter"
                            >
                              <a href="#" onClick={(e) => e.preventDefault()}>
                                <i className="ion-eye"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <h6>
                          <a className="product-name" href="single-product.html">
                            Pendant, Made of White Pl...
                          </a>
                        </h6>

                        <div className="price-box">
                          <span className="new-price">£120.80</span>
                        </div>

                        <div className="additional-add_action">
                          <ul>
                            <li>
                              <a className="hiraola-add_compare" href="wishlist.html">
                                <i className="ion-android-favorite-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <div className="rating-box">
                          <ul>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li><i className="fa fa-star-of-david"></i></li>
                            <li className="silver-color">
                              <i className="fa fa-star-of-david"></i>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpacialOffer;